<div class="player" [class.hide]="displayOverlay">
  <div id="player"></div>
</div>
<div *ngIf="displayOverlay" (click)="play()" class="overlay">
  <ng-content></ng-content>
  <i class="material-icons">play_circle_outline</i>
</div>
